export const isWhitelistedDomain: (url: string) => boolean = (url: string) => {
  try {
    const domain = new URL(url).hostname;
    return WHITELIST.includes(domain);
  } catch {
    return false;
  }
};

const WHITELIST = [
  'akademie-sfg-saar.de',
  'lbbw.com.mx',
  's-unternehmensboerse.de',
  'www.hsgv.de',
  'www.lbb.de',
  'www.sgvsh.de',
  'bewerbermappe.com',
  'www.s-immo-finanz.de',
  'www.sv-bw.de',
  'www.svsaar.de',
  'immobilien.sparkasse.de',
  'paydirekt.sparkasse.de',
  'sparkasseblog.de',
  'sparkassenverband-bayern.de',
  'sparkassenzeitung.de',
  'sparkasse-vor-ort.de',
  'svn.sparkasse.de',
  'www.bausparvertrag.de',
  'www.bayernlb.de',
  'www.berliner-sparkasse.de',
  'www.berlinhyp.de/de',
  'www.countrydesk.de',
  'www.das-forum.de',
  'www.deutsche-leasing.com',
  'www.dsgv.de',
  'www.dsv-gruppe.de',
  'www.f-i.de',
  'www.haspajoker.de',
  'www.helaba.de',
  'www.knax.de',
  'www.kwitt.de',
  'www.lbbw.de',
  'www.lbs.de',
  'www.nordlb.de',
  'www.nsks.de',
  'www.osv-online.de',
  'www.provinzial.de',
  'www.rsgv.de',
  'www.saarlb.de',
  'www.sbroker.de',
  'www.sfirm.de',
  'www.s-immobilien-gmbh.de',
  'www.siz.de',
  'www.s-kreditpartner.de',
  'www.sparkasse.at',
  'www.sparkassen-finanzgruppe-ht.de',
  'www.sparkassen-finanzportal.de',
  'www.sparkassengeschichtsblog.de',
  'www.sparkassen-immo.de',
  'www.sparkassenstiftung.de',
  'www.sparkassenverband.at',
  'www.sparkassenversicherung.de',
  'www.s-rating-risikosysteme.de',
  'www.starfinanz.de',
  'www.starmoney.de',
  'www.svn.de',
  'www.sv-rlp.de',
  'www.sv-sachsen.de',
  'www.svwl.eu',
  'www.s-weltweit.de',
  'www.voev.de',
  'www.wirwunder.de',
  'sc-kapital.de',
  'www.alte-oldenburger.de',
  'www.alvg.de',
  'www.andsafe.de',
  'www.apato.de',
  'www.bad-homburger-inkasso.com',
  'www.bayerncard.de',
  'www.bayerninvest.de',
  'www.berlinhyp.de',
  'www.beteiligungskapital-hannover.de',
  'www.bevestor.de',
  'www.bgv.de',
  'www.bgv.de',
  'www.bgv.de',
  'www.bkk-verbundplus.de',
  'www.brandkasse-aurich.de',
  'www.bsv-beteiligungen.de',
  'www.bw-bank.de',
  'www.bw-equity.de',
  'www.bwk.de',
  'www.countrydesk.de',
  'www.dal.de',
  'www.deka.de',
  'www.dekabank.de',
  'www.dekabank.lu',
  'www.dekabank.lu',
  'www.deka-immobilien.de',
  'www.deutsche-assistance.de',
  'www.deutsche-factoring.de',
  'www.deutsche-leasing.com',
  'www.deutscherueck.de',
  'www.dsgf.de',
  'www.dsgv.de',
  'www.dsv-gruppe.de',
  'www.dsv-service.de',
  'www.dwpbank.de',
  'www.eqpa.de',
  'www.eufiserv.com',
  'www.f-i.de',
  'www.finmas.de',
  'www.f-i-solutions-plus.de',
  'www.f-i-ts.de',
  'www.frankfurter-bankgesellschaft.de',
  'www.ggm-re.de',
  'www.girosolution.de',
  'www.grossmann-berger.de',
  'www.g-sd.de',
  'www.gurgoan.germancentre.com',
  'www.hamburger-feuerkasse.de',
  'www.hanseatische-sparkassenakademie.de',
  'www.haspa-bgm.de',
  'www.haspa-finanzholding.de',
  'www.haspa-hansegrund.de',
  'www.haspa-peb.de',
  'www.helaba.com',
  'www.helaba-invest.de',
  'www.heubeck.de',
  'www.hib-immobewertung.de',
  'www.hlsgmbh.de',
  'www.hsgv.de',
  'www.htsd.de',
  'www.ib-sachsen-anhalt.de',
  'www.ifs-ev.org',
  'www.ifsgmbh.com',
  'www.inasys.de',
  'www.isv-net.de',
  'www.ivv.de',
  'www.kommunalentwicklung.de',
  'www.kreditservices-nord.de',
  'www.ksk-bc.de',
  'www.kskmayen.de',
  'www.kskmse.de',
  'www.ksk-reutlingen.de',
  'www.lbb.de',
  'www.lbbw.de',
  'www.lbbw.de',
  'www.lbbw-am.de',
  'www.lbbw-crem.de',
  'www.lbbw-immobilien.de',
  'www.lbbw-pm.de',
  'www.lbbwvc.de',
  'www.lbs.de',
  'www.lbs-bayern.de',
  'www.lbs-ht.de',
  'www.lbs-immoschleswigholstein.de',
  'www.lbs-immosw.de',
  'www.lbsi-nordwest.de',
  'www.lbsi-ost.de',
  'www.lbsi-saar.de',
  'www.lbs-nord.de',
  'www.lbsost.de',
  'www.lbs-saar.de',
  'www.lbs-sw.de',
  'www.lbswest.de',
  'www.lippische.de',
  'www.mainactio.de',
  'www.marktservices-nord.de',
  'www.mbw-koeln.de',
  'www.mmv-bank.de',
  'www.neueleben.de',
  'www.nordek.de',
  'www.nordfm.de',
  'www.nordholding.de',
  'www.nord-immo.de',
  'www.nordlb.de',
  'www.nosa-online.de',
  'www.nosa-online.de',
  'www.nwk-nwu.de',
  'www.nwk-nwu.de',
  'www.occ.ch',
  'www.occ.eu',
  'www.occ.eu',
  'www.oebav.de',
  'www.oeffentliche.de',
  'www.oeffentliche.de',
  'www.oeffentlicheoldenburg.de',
  'www.oerag.de',
  'www.oesa.de',
  'www.oesa.de',
  'www.oev-online.de',
  'www.osv-online.de',
  'www.payone.com',
  'www.pluscard.de',
  'www.procarre.de',
  'www.proservice.de',
  'www.proservicekoeln.de',
  'www.protect-versicherung.de',
  'www.provinzial.com',
  'www.provinzial.de',
  'www.provinzial-konzern.de',
  'www.rbb-beteiligungen.de',
  'www.realisag.de',
  'www.rsgv.de',
  'www.rsu-rating.de',
  'www.saarland-versicherungen.de',
  'www.saarland-versicherungen.de',
  'www.saarlb.de',
  'www.s-akademie.de',
  'www.saleg.de',
  'www.sbargeldlogistik.de',
  'www.s-beteiligung.de',
  'www.s-beteiligung-vorderpfalz.de',
  'www.s-boden-gmbh.de',
  'www.sbroker.de',
  'www.s-c.de',
  'www.scdlz.de',
  'www.s-dln.de',
  'www.s-einkauf.com',
  'www.s-factoring.de',
  'www.sfinanzdienste.de',
  'www.s-finanz-euskirchen.de',
  'www.sg-k.de',
  'www.sgvsh.de',
  'www.sgz-datenservice.de',
  'www.s-hochschule.de',
  'www.s-iba.eu',
  'www.sib-dresden.de',
  'www.siegerlandfonds.de',
  'www.s-int.de',
  'www.si-rr.de',
  'www.s-it-service.de',
  'www.siz-service.de',
  'www.ska.nrw',
  'www.s-kap.de',
  'www.s-kreditpartner.de',
  'www.s-markt-mehrwert.de',
  'www.solum.de',
  'www.sparkasse-bremen.de',
  'www.sparkasse-gelsenkirchen.de',
  'www.sparkasse-immobilien-essen.de',
  'www.sparkasse-loerrach.de',
  'www.sparkassen.immo',
  'www.sparkassen-akademie.de',
  'www.sparkassenakademie-bayern.de',
  'www.sparkassen-beteiligung.de',
  'www.sparkassen-direkt.de',
  'www.sparkassen-direkt.de',
  'www.sparkassen-finanzgruppe-ht.de',
  'www.sparkassen-finanzgruppe-saar.de',
  'www.sparkassen-finanzportal.de',
  'www.sparkassen-immo.de',
  'www.sparkassenstiftung.de',
  'www.sparkassenverband-bayern.de',
  'www.sparkassenversicherung.de',
  'www.sparkasse-ulm.de',
  'www.s-payment.com',
  'www.s-pension.de',
  'www.spk-akademie.de',
  'www.spk-immobilien.de',
  'www.s-private-banking.com',
  'www.s-profinanz.de',
  'www.s-rating-risikosysteme.de',
  'www.src-gmbh.de',
  'www.s-servicepartner.de',
  'www.starfinanz.de',
  'www.stiftung-wissenschaft.de',
  'www.s-ubg.de',
  'www.s-ubg.de',
  'www.suedbg.de',
  'www.suedfactoring.de',
  'www.suedleasing.de',
  'www.sv-bav.de',
  'www.sv-bw.de',
  'www.sv-informatik.de',
  'www.svwl.eu',
  'www.s-wagnis.de',
  'www.targens.de',
  'www.tevea-international.com',
  'www.tgfs.de',
  'www.ukv.de',
  'www.urv.de',
  'www.verband-freier-sparkassen.de',
  'www.vgh.de',
  'www.vkb.de',
  'www.voev.de',
  'www.wachstumsfonds-sachsen.de',
  'www.weberbank.de',
  'www.west-factoring.de',
  'www.westinvest.de',
  'www.wrz.de',
  'www.wsbi-esbg.org',
];
